var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeatherFog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.5 11.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.64,5.95c0-1.66-1.34-3-3-3-.19,0-.38.02-.56.06-.33-1.29-1.5-2.25-2.9-2.25s-2.56.95-2.89,2.24c-.14-.02-.29-.04-.44-.04-1.66,0-3,1.34-3,3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.5,
    y1: 7.93,
    x2: 14,
    y2: 7.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.5,
    y1: 9.49,
    x2: 14,
    y2: 9.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.5,
    y1: 11.06,
    x2: 14,
    y2: 11.06
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherFog);
export default __webpack_public_path__ + "static/media/icon_weather_fog.bb1c0ec7d0842a3713ef864de06145bd.svg";
export { ForwardRef as ReactComponent };